import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export type ButtonVariant = 'default' | 'primary';
export type ButtonSize = 'default' | 'large';

@Component({
  selector: 'app-az-button',
  imports: [],
  templateUrl: './az-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './az-button.component.scss',
})
export class AzButtonComponent {
  @Input() label: string = '';
  @Input() icon: string = '';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() showIcon: boolean = true;
  @Input() variant: ButtonVariant = 'default';
  @Input() size: ButtonSize = 'default';
  @Input() disabled: boolean = false;
}
